export function convertQuillHtmlToInlineAndClassHtml(html) {
  const container = document.createElement('div');
  container.innerHTML = html;

  const fontClassToFamily = {
    'ql-font-monospace': 'monospace',
    'ql-font-montserrat': 'montserrat',
    'ql-font-roboto': 'roboto',
    'ql-font-arial': 'arial',
    'ql-font-serif': 'serif',
  };

  const sizeClassToPx = {
    'ql-size-6px': '6px',
    'ql-size-8px': '8px',
    'ql-size-12px': '12px',
    'ql-size-16px': '16px',
    'ql-size-18px': '18px',
    'ql-size-24px': '24px',
  };

  function processElement(el) {
    if (el.nodeType !== Node.ELEMENT_NODE) return;

    const classes = Array.from(el.classList);
    const styleMap = new Map();

    classes.forEach((cls) => {
      if (fontClassToFamily[cls]) {
        styleMap.set('font-family', fontClassToFamily[cls]);
      }
      if (sizeClassToPx[cls]) {
        styleMap.set('font-size', sizeClassToPx[cls]);
      }
    });

    // Preserve inline styles
    const inlineStyle = el.getAttribute('style') || '';
    const newStyleParts = [...styleMap.entries()].map(
      ([key, val]) => `${key}:${val}`
    );
    const finalStyle = [...newStyleParts, inlineStyle]
      .filter(Boolean)
      .join('; ');

    if (finalStyle) {
      el.setAttribute('style', finalStyle);
    }
  }

  const walk = (node) => {
    if (node.nodeType === Node.ELEMENT_NODE) {
      processElement(node);
      node.childNodes.forEach(walk);
    }
  };

  container.childNodes.forEach(walk);
  return container.innerHTML;
}
